export default __webpack_public_path__ + "static/media/American Amicable Dark.85814e66.svg";